import React from 'react';
import { UploadedFile } from 'components/shareable/UniversalUploadWidget/UniversalUploadWidget';
import UploadedFilePreview from 'components/shareable/UploadedFilePreview/UploadedFilePreview';
import { CSSProperties } from 'react';

interface MessageUploadedAssetsProps {
    uploadedAssets: UploadedFile[];
    className?: string;
    style?: CSSProperties;
}

const MessageUploadedAssets: React.FC<MessageUploadedAssetsProps> = ({ 
    uploadedAssets, 
    className = '', 
    style = {} 
}) => {
    const handleAssetClick = (asset: UploadedFile) => {
        // Handle click to view/download
        if (asset.s3Url) {
            window.open(asset.s3Url, '_blank');
        }
    };

    const sty: Record<string, CSSProperties> = {
        messageUploadedAssets: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 12,
            marginTop: 8,
            marginBottom: 8,
            ...style
        }
    };

    return (
        <div className={`messageUploadedAssets ${className}`} style={sty.messageUploadedAssets}>
            {uploadedAssets.map((asset) => (
                <UploadedFilePreview
                    key={asset.id}
                    file={asset}
                    layout="vertical"
                    showRemoveButton={false}
                    showProgress={false}
                    onClick={handleAssetClick}
                />
            ))}
        </div>
    );
};

export default MessageUploadedAssets; 